import { create } from "zustand";
import featureService from "../services/feature.service";

const CACHE_TIME = 5 * 60 * 1000; // 5 phút

const useFeatureStore = create((set, get) => ({
  // State
  features: {}, // { subscription_id: [features] }
  loading: false,
  error: null,
  lastFetched: null,

  // Actions
  fetchFeatures: async (force = false) => {
    const { lastFetched, features } = get();
    const now = Date.now();

    // Nếu đã có cache và chưa hết hạn, return cache
    if (!force && lastFetched && now - lastFetched < CACHE_TIME && Object.keys(features).length > 0) {
      return features;
    }

    set({ loading: true, error: null });

    try {
      const response = await featureService.getAllFeatures();
      const featuresData = response.payload || {};

      set({
        features: featuresData,
        loading: false,
        lastFetched: now,
      });

      return featuresData;
    } catch (error) {
      const errorMessage = error.message || error.msg || "Failed to fetch features";
      set({
        error: errorMessage,
        loading: false,
      });
      // Throw Error object instead of raw object
      throw new Error(errorMessage);
    }
  },

  // Helper: Lấy features của một subscription
  getFeaturesBySubscriptionId: (subscriptionId) => {
    const { features } = get();
    return features[subscriptionId] || [];
  },

  // Clear cache
  clearCache: () => {
    set({
      features: {},
      lastFetched: null,
    });
  },
}));

export default useFeatureStore;

